module.exports = __webpack_public_path__ + "static/media/dark-mode.40fcd0e4.svg";